import { Link } from "react-router-dom";

const quickLinks = [
  { label: "Startseite", href: "/" },
  { label: "Sträuße & Geschenk", href: "/strauss-geschenk" },
  { label: "Hochzeitsfloristik", href: "/hochzeit" },
  { label: "Trauerfloristik", href: "/trauer" },
  { label: "Event & Firma", href: "/event" },
  { label: "Pflanzen", href: "/pflanzen" },
];

const kontaktLinks = [
  { label: "Über uns", href: "/ueber-uns" },
  { label: "Kontakt", href: "/kontakt" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          {/* Navigation */}
          <div>
            <h3 className="font-heading text-lg text-foreground-950 mb-4">Navigation</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Öffnungszeiten */}
          <div className="w-fit">
            <h3 className="font-heading text-lg text-foreground-950 mb-4">Öffnungszeiten</h3>
            <div className="text-sm text-foreground-600 space-y-1.5">
              <div className="grid grid-cols-[auto_auto] gap-x-6"><span>Mo–Di</span><span className="text-right">08:30–18:00</span></div>
              <div className="grid grid-cols-[auto_auto] gap-x-6"><span>Mi</span><span className="text-right">geschlossen</span></div>
              <div className="grid grid-cols-[auto_auto] gap-x-6"><span>Do–Fr</span><span className="text-right">08:30–18:00</span></div>
              <div className="grid grid-cols-[auto_auto] gap-x-6"><span>Sa</span><span className="text-right">08:30–13:00</span></div>
              <div className="grid grid-cols-[auto_auto] gap-x-6"><span>So</span><span className="text-right">10:30–12:30</span></div>
            </div>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              An Feiertagen können abweichende Zeiten gelten.
            </p>
          </div>

          {/* Partner + Kontakt */}
          <div>
            <h3 className="font-heading text-lg text-foreground-950 mb-4">Partner</h3>
            <a
              href="https://www.fleurop.de"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-foreground-500 hover:text-primary-600 transition-colors mb-6 inline-block"
            >
              Offizieller Fleurop 5-Sterne-Florist – Blumen online versenden
            </a>

            {/* Kontakt-Box */}
            <div className="mt-4">
              <h3 className="font-heading text-lg text-foreground-950 mb-4">Kontakt</h3>
              <div className="space-y-3">
                <a
                  href="tel:+494914238"
                  className="flex items-center gap-3 text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-md">
                    <i className="ri-phone-line w-4 h-4 flex items-center justify-center text-base" />
                  </div>
                  <span className="font-medium">0491 4238</span>
                </a>
                <a
                  href="mailto:info@blumen-stoehr.de"
                  className="flex items-center gap-3 text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  <div className="w-8 h-8 flex items-center justify-center bg-secondary-500 text-background-50 rounded-md">
                    <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-base" />
                  </div>
                  <span className="font-medium">info@blumen-stoehr.de</span>
                </a>
              </div>
              <ul className="space-y-1.5 mt-3 pt-3 border-t border-background-200/70">
                {kontaktLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-6 text-sm text-foreground-500">
            <a
              href="https://www.coonex-digital.de"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary-600 transition-colors"
            >
              © {new Date().getFullYear()} Connex-Digital GmbH
            </a>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <span>Heisfelder Straße 105, 26789 Leer</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <span>Tel. 0491 4238</span>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/impressum" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
              Datenschutz
            </Link>
            <Link to="/ki-transparenz" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
              KI-Transparenz
            </Link>
            <a
              href="https://www.instagram.com/florale_manufaktur/?hl=de"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-background-200/70 rounded-sm flex items-center justify-center text-foreground-500 hover:text-primary-600 hover:bg-background-300/70 transition-colors"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram text-base" />
            </a>
            <a
              href="https://www.facebook.com/blumenstoehr"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-background-200/70 rounded-sm flex items-center justify-center text-foreground-500 hover:text-primary-600 hover:bg-background-300/70 transition-colors"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f text-base" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}